var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3656_13903)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4999 2C10.329 2 9.37233 2.29581 8.63943 2.88435C7.91367 3.46716 7.51275 4.25263 7.28843 5.03779C7.19858 5.35228 7.13439 5.67592 7.08872 6H7C4.23858 6 2 8.23858 2 11V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V11C22 8.23858 19.7614 6 17 6H16.3798C16.3238 5.66237 16.2455 5.32454 16.1361 4.99627C15.8681 4.19232 15.4021 3.41386 14.6005 2.8474C13.8028 2.28369 12.7719 2 11.4999 2ZM14.5167 8C14.517 8.2553 14.5127 8.50437 14.5084 8.75455L14.5084 8.75469C14.5042 8.99977 14.5 9.24591 14.5 9.5C14.5 10.0523 14.9477 10.5 15.5 10.5C16.0522 10.5 16.5 10.0523 16.5 9.5C16.5 9.31327 16.5035 9.09894 16.5072 8.86867V8.86865C16.5117 8.59509 16.5165 8.29902 16.5162 8H17C18.6569 8 20 9.34315 20 11V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V11C4 9.34962 5.33268 8.0105 6.9806 8.00006C6.98197 8.2732 6.98677 8.54615 6.99126 8.80101V8.80102C6.99579 9.05865 7 9.29781 7 9.5C7 10.0523 7.44772 10.5 8 10.5C8.55229 10.5 9 10.0523 9 9.5C9 9.2181 8.99491 8.94982 8.98983 8.68239C8.98555 8.45687 8.98128 8.23195 8.98009 8H14.5167ZM14.3424 6C14.3127 5.87131 14.2783 5.74742 14.2388 5.62873C14.0692 5.12018 13.8165 4.74239 13.4463 4.48073C13.0721 4.21631 12.478 4 11.4999 4C10.6709 4 10.1901 4.20419 9.8917 4.44378C9.58622 4.68909 9.36215 5.05987 9.21149 5.58721C9.17386 5.71891 9.14188 5.85671 9.11482 6H14.3424Z",
    fill: "#292F4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3656_13903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJobs);
export default __webpack_public_path__ + "static/media/ic_jobs.564a902f7500cf257a3d241ab2f524e9.svg";
export { ForwardRef as ReactComponent };